import { render, staticRenderFns } from "./MiniDepStatTableDepTime.component.vue?vue&type=template&id=4afae237&scoped=true&"
import script from "./MiniDepStatTableDepTime.component.vue?vue&type=script&lang=js&"
export * from "./MiniDepStatTableDepTime.component.vue?vue&type=script&lang=js&"
import style0 from "./MiniDepStatTableDepTime.component.vue?vue&type=style&index=0&id=4afae237&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afae237",
  null
  
)

export default component.exports